import { render, staticRenderFns } from "./GoodsTabsChoose.vue?vue&type=template&id=7b6a5aba&scoped=true"
import script from "./GoodsTabsChoose.vue?vue&type=script&lang=js"
export * from "./GoodsTabsChoose.vue?vue&type=script&lang=js"
import style0 from "./GoodsTabsChoose.vue?vue&type=style&index=0&id=7b6a5aba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6a5aba",
  null
  
)

export default component.exports